<template>
  <div class="info-wrp">
    <div class="title">
      <ChangeCompany/>
    </div>
    <DetailForm :detailList="companyDetailList" :detailData="defaultCompany" showCopy />
    <div class="btn-wrp">
      <van-button
        class="btn"
        round
        @click="copyAll"
      >
        复 制
      </van-button>
    </div>
  </div>
</template>

<script>
import ChangeCompany from '@components/ChangeCompany'
import Observer from '@utils/observer'
import {
  Notify
} from 'vant'
import { accountRequest } from '@services'
import DetailForm from '@components/DetailForm/index.vue'
export default {
  data () {
    return {
      defaultCompany: {
        name: '',
        taxNo: '',
        address: '',
        bankName: '',
        specialMaxAmount: 0,
        generalMaxAmount: 0,
        electronicMaxAmount: 0
      },
      companyDetailList: [
        {
          field: 'name',
          label: '客户名称'
        },
        {
          field: 'taxNo',
          label: '客户税号'
        },
        {
          field: 'address',
          label: '地址、电话'
        },
        {
          field: 'bankName',
          label: '开户行、账号'
        }
      ]
    }
  },
  mounted () {
    this.getCurrentCompany()
    Observer.setFunction({ type: 'changeCompany', fn: this.companyChangeRefresh })
  },
  computed: {},
  methods: {
    companyChangeRefresh () {
      if (window.location.pathname === '/user-center/company-info') {
        this.getCurrentCompany()
      }
    },
    async getCurrentCompany () {
      const postData = {
        size: 9999
      }
      const data = await accountRequest.company.getCompanyList(postData)
      if (data.success) {
        if (!data.result) {
          return
        }
        const {
          records,
          currentCompany
        } = data.result
        this.companyList = records
        this.defaultCompany = currentCompany
        this.deviceList = currentCompany.deviceList
        const currentCompanyData = await accountRequest.company.getCompanyDetail({}, { id: currentCompany.id })
        if (currentCompanyData.success) {
          if (!currentCompanyData.result || !currentCompanyData.result.companyInfoResponse) {
            return
          }
          const {
            specialMaxAmount,
            generalMaxAmount,
            electronicMaxAmount
          } = currentCompanyData.result.companyInfoResponse
          this.defaultCompany = {
            ...this.defaultCompany,
            specialMaxAmount,
            generalMaxAmount,
            electronicMaxAmount
          }
        } else {
          Notify({ type: 'danger', message: currentCompanyData.message })
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    copyAll () {
      let text = `公司名称：${this.defaultCompany.name}
公司税号：${this.defaultCompany.taxNo}
地址电话：${this.defaultCompany.address}
开户行、账号：${this.defaultCompany.bankName}
`
      let textArea = document.createElement('textarea')
      textArea.style.position = 'fixed'
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.width = '2em'
      textArea.style.height = '2em'
      textArea.style.padding = '0'
      textArea.style.border = 'none'
      textArea.style.outline = 'none'
      textArea.style.boxShadow = 'none'
      textArea.style.background = 'transparent'
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.select()
      try {
        let successful = document.execCommand('copy')
        if (successful) {
          Notify({ type: 'success', message: '文本已经复制到剪贴板' })
        } else {
          Notify({ type: 'danger', message: '您的浏览器不支持一键复制，请自行选中文字复制' })
        }
      } catch (err) {
        Notify({ type: 'danger', message: '您的浏览器不支持一键复制，请自行选中文字复制' })
      }
      document.body.removeChild(textArea)
    },
    cancel () {
      this.$router.go(-1)
    }
  },
  components: {
    DetailForm,
    ChangeCompany,
    [Notify.name]: Notify
  }
}
</script>

<style lang="less" scoped>
.info-wrp {
  width: 100%;
  height: 100%;
  background: #fff;
  /deep/.info-item {
    border-bottom: solid 1Px #edf2f6;
    padding: 40px 30px;
    background-color: #fff;
  }
  .title{
    height: 100px;
  }
  .label{
    width: 200px;
    font-size:28px;
    line-height: 28px;
    color:rgba(51,51,51,1);
  }

  .value {
    font-size:26px;
    line-height: 28px;
    color:rgba(51,51,51,1);
    p + p {
      margin-top: 20px;
    }
  }
  .btn-wrp{
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    margin-top: 19px;
    position: fixed;
    bottom: 60px;
    .btn{
      width: 90%;
      height: 90px;
      background: #2372FF;
      border-radius: 12px;
      color: #fff;
      font-size: 32px;
      font-weight: 500;
      line-height: 90px;
      text-align: center;
    }
  }
}
</style>
